
import {Component, Vue} from "vue-property-decorator";
import {DateTime} from "luxon";
import {Pattern} from "@/addons/Pattern";
import {sancionStore} from "@/store/sancionStore";
import {SancionService} from "@/services/SancionService";
import SancionShow from "@/views/sanciones/SancionShow.vue";
import SancionNew from "@/views/sanciones/SancionNew.vue";
import {Alert} from "@/addons/Alert";
import SancionObservar from "@/views/sanciones/observar.vue";
import router from "@/router";
import {empresaStore} from "@/store/empresaStore";
import {EmpresaService} from "@/services/EmpresaService";


@Component({
  name: "EmpresaIndex",
  components: {SancionObservar, SancionNew, SancionShow},
})
export default class SancionIndex extends Vue {
  private patterns = Pattern;
  search = null
  private sancionStore = sancionStore();
  private empresaStore = empresaStore();

  private sancionService = SancionService.getInstance();
  private empresaService = EmpresaService.getInstance();
  private fechaInicial = DateTime.now().toFormat("yyyy-MM-dd");
  private fechaFinal = DateTime.now().toFormat("yyyy-MM-dd");
  private sancionSeleccionada: any = null;

  private isObservar = false;

  grupo_id = "Todos";



  get materiales(): any[] {
    return this.empresaStore.empresasListado;
  }


  get loading(): boolean {
    return this.empresaStore.loading;
  }

  get pagination(): any {
    return this.empresaStore.pagination;
  }




  mounted() {
    this.listar();
  }


  listar() {
    const data = {
      search: this.search,
      page: this.pagination.current_page
    };
    this.empresaService.index(data);
  }

  editar(empresa:any){
    router.push({name: 'empresaEdit', params: {empresaEdit: empresa}})
  }

  openSancionNew(sancion:any, isNew:boolean) {
    router.push({name: 'empresaNew'});
  }


  eliminarMaterial(material:any) {
    Alert.confirm(`Eliminar el Material al: <br>
                    Cliente: ${material.nombre}`
    ).then(res => {
      const data = {materialId: material.id}
      if (res.isConfirmed) {
        this.empresaService.deleteEmpresa(data);
        this.listar();
      }
    })
  }

  closeSancion() {
    this.sancionStore.showDialogSancion = false;
    this.sancionStore.sancion = []
    this.sancionStore.cliente = []
    this.sancionStore.isNew = false;
  }
}
